import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isAuthenticated } from "utils/common";
import { checkToken } from "features/User/userSlice";
import { useState } from "react";
import { Route } from "react-router-dom";

const PublicRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();

  const [isRender, setIsRender] = useState(false);
  const { isCheck } = useSelector((state) => state.user);

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch(checkToken());
    } else {
      setIsRender(true);
    }
  }, []);

  useEffect(() => {
    if (isCheck) {
      setIsRender(true);
    }
  }, [isCheck]);

  if (!isRender) return null;

  return <Route {...rest} component={Component} />;
};

export default PublicRoute;
